import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class tableMixin extends Vue {
  private cList: any = [];

  public chapterId: string = '';

  private column: Array<ITABLECOLCONF> = [{
    label: '作业类型',
    prop: 'questionTypeLabel',
    align: 'center',
    width: '150px',
  }, {
    label: '课程类型',
    prop: 'courseType',
    align: 'center',
    width: '150px',
  },
  {
    label: '难易程度',
    prop: 'difficultyLabel',
    align: 'center',
    width: '200px',
  },
  {
    label: '知识点',
    prop: 'knowledgeLabel',
    align: 'center',
    width: '150px',
  }, {
    label: '排序',
    prop: 'sort',
    align: 'center',
    width: '60px',
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '修改',
        name: '/course/chapter/homework:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '课程信息 - 修改',
          component: '/course/info:update',
        },
      },
      {
        title: '添加/修改内容',
        name: '/course/chapter/homework:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleContent,
        log: {
          name: '课程信息 - 修改',
          component: '/course/chapter/homework:remvoe',
        },
      },
      {
        title: '删除',
        name: '/course/info:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '课程信息 - 删除',
          component: '/course/chapter/homework:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  private questions: any = [];

  private difficulties: any = [];

  private knowledges: any = [];

  getData(pid: string) {
    return new Promise((resolve, reject) => {
      api.getHomework(pid).then((res: any) => {
        this.cList = res;
        this.chapterId = pid;
        resolve(res);
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  handleOperate(row: any) {}

  handleContent(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该作业吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeHomework(row.pid).then(() => {
        close();
        this.getData(this.chapterId);
        this.$log({
          title: '正式课管理 - 作业 - 确定',
          component: 'course/chapter/rescource',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '正式课管理 - 课程资源删除 - 取消',
      component: 'course/chapter/rescource',
    }));
  }
}
